import { useSearchParams } from "react-router-dom";
import type { PayrollRosterRowFocus } from "./types";

export const useRosterRowFocus = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get("focus");
  const focus = value === "missing" || value === "departed" ? value : null;
  const setFocus = (next: PayrollRosterRowFocus) => {
    setSearchParams(
      (current) => {
        const params = new URLSearchParams(current);
        if (next) params.set("focus", next);
        else params.delete("focus");
        return params;
      },
      { replace: true },
    );
  };

  return [focus, setFocus] as const;
};
